// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --app-page-bg: #f7f7fb;
  --app-page-background:
    radial-gradient(ellipse 30% 35% at 0% 0%, rgba(255, 180, 130, 0.45) 0%, transparent 70%),
    radial-gradient(ellipse 28% 35% at 100% 100%, rgba(190, 210, 255, 0.38) 0%, transparent 70%),
    var(--app-page-bg);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
  scroll-behavior: smooth;
}

html,
body,
#root {
  min-height: 100%;
}

html,
body {
  background: var(--app-page-background) !important;
  background-attachment: fixed;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Use on every page wrapper so layout fills the viewport */
.app_page {
  min-height: 100vh;
  background: transparent;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB;;;sBAGoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,2DAA2D;AAC3D;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,+EAA+E;AACjF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n:root {\n  --app-page-bg: #f7f7fb;\n  --app-page-background:\n    radial-gradient(ellipse 30% 35% at 0% 0%, rgba(255, 180, 130, 0.45) 0%, transparent 70%),\n    radial-gradient(ellipse 28% 35% at 100% 100%, rgba(190, 210, 255, 0.38) 0%, transparent 70%),\n    var(--app-page-bg);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Poppins\", sans-serif;\n  scroll-behavior: smooth;\n}\n\nhtml,\nbody,\n#root {\n  min-height: 100%;\n}\n\nhtml,\nbody {\n  background: var(--app-page-background) !important;\n  background-attachment: fixed;\n}\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Use on every page wrapper so layout fills the viewport */\n.app_page {\n  min-height: 100vh;\n  background: transparent;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
